
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'LocationTransportAccessibilityBlock',

    components: {
        Location: () => import('./components/LocationTransportAccessibilityBlock/Location'),
        TransportAccessibility: () => import('./components/LocationTransportAccessibilityBlock/TransportAccessibility'),
    },
});
